import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import React, { forwardRef } from 'react'
import { IcomoonIcon } from '../../IcomoonIcon'

type Props = {
  label: string
  selectedText: string | null
  options: React.ReactElement
  onClick: () => void
  emptyText?: string
  isLabelOut?: boolean
  errorText?: string
  className?: string
}

export const FilterSelect = forwardRef<HTMLDivElement, Props>(
  function FilterSelectChild(props, ref) {
    if (props.isLabelOut) {
      return (
        <div
          className={props.className}
          css={css`
            position: relative;
          `}
          ref={ref}
        >
          <div
            className="filter-label"
            css={css`
              color: ${colors.textLight};
              font-size: 12px;
              margin-left: 8px;
              margin-bottom: 8px;
              line-height: 1;
            `}
          >
            {props.label}
          </div>
          <FilterSelectButton
            {...props}
            emptyText={props.emptyText || '指定なし'}
            onClick={props.onClick}
          />
          <div
            css={css`
              position: absolute;
              left: 0px;
              top: 53px;
              z-index: 3;
            `}
          >
            {props.options}
          </div>
        </div>
      )
    }

    return (
      <div
        className={props.className}
        css={css`
          position: relative;
        `}
        ref={ref}
      >
        <FilterSelectButton {...props} onClick={props.onClick} />
        <div
          css={css`
            position: absolute;
            left: 5px;
            top: 32px;
            z-index: 3;
          `}
        >
          {props.options}
        </div>
      </div>
    )
  }
)

const FilterSelectButton: React.FC<Props> = (props) => {
  const text = buttonText(props)
  const { text: textColor, bg, hoverBg } = colorsOf(props)

  return (
    <div
      className="filter-select-button"
      onClick={props.onClick}
      css={css`
        background-color: ${bg};
        border-radius: 100px;
        padding: 3px 4px 3px 14px;
        display: inline-flex;
        border-radius: 100px;
        justify-content: space-between;
        align-items: center;
        transition: 0.3s;
        cursor: pointer;
        user-select: none;

        &:hover {
          background-color: ${hoverBg};
        }
      `}
    >
      <div
        className="filter-selected-item"
        css={css`
          color: ${textColor};
          font-size: 14px;
        `}
      >
        {props.errorText && (
          <IcomoonIcon
            name="alert-fill"
            css={css`
              font-size: 16px;
              margin-right: 3px;
              vertical-align: bottom;
            `}
          />
        )}
        {text}
      </div>
      <div
        css={css`
          margin-left: 6px;
          background-color: rgba(0, 0, 0, 0.1);
          border-radius: 50%;
          right: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 18px;
          height: 18px;
        `}
      >
        <IcomoonIcon
          name="arrow7-down"
          css={css`
            color: ${textColor};
          `}
        />
      </div>
    </div>
  )
}

const buttonText = (props: Props): string | undefined => {
  if (props.errorText && props.isLabelOut) {
    return props.errorText
  } else if (props.errorText && !props.isLabelOut) {
    return props.label
  } else if (props.selectedText && !props.isLabelOut) {
    return `${props.label}：${props.selectedText}`
  } else if (props.selectedText && props.isLabelOut) {
    return props.selectedText
  } else if (props.isLabelOut) {
    return props.emptyText
  } else {
    return props.label
  }
}

type Colors = {
  text: string
  bg: string
  hoverBg: string
}

const colorsOf = (props: Props): Colors => {
  if (props.errorText) {
    return {
      text: colors.white00,
      bg: colors.red50,
      hoverBg: colors.red60,
    }
  } else if (props.selectedText) {
    return {
      text: colors.white00,
      bg: colors.cyan50,
      hoverBg: colors.cyan60,
    }
  } else {
    return {
      text: colors.textStrong,
      bg: colors.gray50,
      hoverBg: colors.gray60,
    }
  }
}
